import type { CategoryExposure } from './FilterRow.types';

export const OPTION_PILLS_COUNT = 2;

export const CATEGORY_SPECIFIC_EXPOSURE: CategoryExposure = { mode: 'categorySpecific' };
